<template>
  <div class="Search">
    <form
        @submit="doSearch($event)"
        class="Search-form">
      <toggle
          class="Search-toggle"
          @change="searchType($event)"
          :selected="searchBy"
          :options="['ticket', 'event', 'user']">
      </toggle>

      <toggle
          class="Search-toggle"
          @change="upcomingToggle($event === 'upcoming')"
          :selected="onlyUpcoming ? 'upcoming' : 'all'"
          :options="['all', 'upcoming']">
      </toggle>

      <input-field
          class="Search-field"
          v-model="search"
          @change="search = $event"
          placeholder="Search"
          :definition="{
          label: 'Search '+ searchBy+'s',
        }">
      </input-field>
      <button
          class="Button Search-button"
          type="submit">
        Search
      </button>
      <div
          v-if="asyncFormError">
        <p>{{ asyncFormError }}</p>
      </div>
    </form>


    <div class="FlexTable" v-if="previousSearch !== ''">
      <div class="FlexTable-header">
        <h3 class="FlexTable-title">
          {{ searchResults.data.length }} search result<span v-if="searchResults.data.length > 1">s</span> for <span
            class="Chip">{{ previousSearch }}</span>
          <span class="Chip" v-if="onlyUpcoming">Upcoming only</span>
        </h3>
        <h3 class="FlexTable-title" v-if="searchResults.data.length > 0">
          Searched by <span class="Chip">{{ searchResults.searchType }}</span>
        </h3>
      </div>
      <p
          class="FlexTable-content FlexTable-contentItem"
          v-if="searchResults.data.length === 0">
        No results
      </p>
      <ve-table
          class="Payments-table"
          row-key-field-name="id"
          :fixed-header="true"
          :columns="tableColumns"
          :table-data="searchResultsData"
          :cell-style-option="cellStyleOption"
          :editOption="editOption"
          :rowStyleOption="rowStyleOption"
          :expand-option="expandOption"
          :clipboard-option="{copy:true}"
      />
    </div>
    <transfer
        v-if="showTransfer"
        :ticket="transferSubject"
        @close="showTransfer = !$event; transferSubject = false">
    </transfer>
    <refund v-if="showRefund" :ticket="refundSubject" @close="showRefund = !$event; refundSubject = false"></refund>
    <form-wrapper
      v-if="showForm"
      @close="showForm = !$event"
      :title="formTitle"
      :schema="formSchema"
      :url="formUrl"></form-wrapper>
  </div>
</template>

<script>
import './Search.scss';

import axios from "axios";
import errorModel from '../../models/error';
import cookieModel from '../../models/cookie';
import Transfer from "../../components/transfer/transfer";
import $router from '../../router';
import FormWrapper from "../../components/form-wrapper/form-wrapper.vue";
import {toArray} from "lodash";

export default {
  components: {
    FormWrapper,
    Transfer,
  },
  mounted() {
    const urlChange = () => {
      const queryParams = $router.currentRoute.query;

      if (queryParams.search) {
        this.search = queryParams.search;
      }

      if (queryParams.searchType) {
        this.searchType(queryParams.searchType);
      }

      if (queryParams.onlyUpcoming) {
        this.upcomingToggle(queryParams.onlyUpcoming === 'true');
      }

      if (queryParams) {
        this.doSearch();
      }
    };

    window.addEventListener('popstate', urlChange);

    // Useful for cleanup when component is destroyed
    this.cleanup = urlChange;

    urlChange();
  },

  beforeDestroy() {
    // It is important to remove the handler when component is getting destroyed
    window.removeEventListener('popstate', this.cleanup);
  },
  props: {},
  computed: {},
  methods: {
    // do search
    doSearch: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      const vm = this;
      let url = '';

      switch (vm.searchBy) {
        case 'ticket':
        default:
          url = this.baseUrl + "/einstein/ticket/search";
          vm.tableColumns = vm.ticketColumns;
          break;
        case 'event':
          url = this.baseUrl + "/events/search";
          vm.tableColumns = vm.eventColumns;
          break;
        case 'user':
          url = this.baseUrl + "/einstein/user/search";
          vm.tableColumns = vm.userColumns;
          break;
      }

      // reset error message
      vm.asyncFormError = '';
      let postData = {};

      if (vm.search.length < 2) {
        vm.searchResults = [];
        vm.previousSearch = '';
        vm.asyncFormError = "Please enter at least 2 characters";
        return;
      }
      postData['search'] = vm.search;
      postData['upcomingOnly'] = vm.onlyUpcoming;

      vm.updateQueryParams({
        'search': vm.search,
        'searchType': vm.searchBy,
        'onlyUpcoming': vm.onlyUpcoming,
      });

      // Add authorisation to request header
      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      vm.axiosInstance.post(url, postData)
          .then(function (response) {
            console.log('response: ', response.data)
            if (response.data && response.data.status === "success") {
              // reset error
              vm.asyncFormError = false;
              vm.previousSearch = vm.search;
              vm.searchResults = response.data;
              vm.searchResultsData = toArray(response.data.data);
              vm.disableForm = false;
            } else {
              console.log('nada', response);
              vm.asyncFormError = response.data.status + ': ' + response.data.message;
            }
          }).catch(function (error) {
        vm.asyncFormError = errorModel.apiError(error, vm.$router);
        vm.disableForm = false;
      });
    },
    transfer: function (ticket) {
      console.log('transfer', ticket.code);
      this.showTransfer = true;
      this.transferSubject = ticket;
    },
    refund: function (ticket) {
      console.log('refund', ticket.code);
      this.showRefund = true;
      this.refundSubject = ticket;
    },
    markEventAsSpam: function (event) {
      const vm = this;
      vm.asyncFormError = '';
      vm.disableForm = true;

      // Add authorisation to request header
      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      const postData = {
        event_id: event.id
      };

      vm.axiosInstance.post(vm.baseUrl + "/admin/spam/mark", postData)
        .then(function (response) {
          console.log('response: ', response.data);
          if (response.data && response.data.success) {
            // Update the event status in the local data
            event.status = 7;
            event.status_type = 'SPAM';
            vm.asyncFormError = false;
            vm.disableForm = false;
          } else {
            vm.asyncFormError = response.data.message || 'Failed to mark event as spam';
            vm.disableForm = false;
          }
        }).catch(function (error) {
          vm.asyncFormError = errorModel.apiError(error, vm.$router);
          vm.disableForm = false;
        });
    },
    showTickets: function (eventId) {
      const vm = this;
      vm.searchBy = 'ticket';
      vm.search = eventId;
      vm.upcomingOnly = false;
      vm.doSearch()
    },
    searchType: function (newType) {
      const vm = this;
      vm.searchResults = [];
      vm.previousSearch = '';
      vm.searchBy = newType
    },
    upcomingToggle: function (updatedValue) {
      this.onlyUpcoming = Boolean(updatedValue);
    },
    optInDataRelease: function (row) {
      const vm = this;
      vm.asyncFormError = '';
      vm.disableForm = true;
      // Add authorisation to request header
      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      let postData = {
        'userId': row.id
      };

      // Do a call to the search api for guest name
      vm.axiosInstance.post(vm.baseUrl + "/einstein/merchant/data-release", postData)
          .then(function (response) {
            console.log('response: ', response.data)
            if (response.data && response.data.status === "success") {
              // reset error
              vm.asyncFormError = false;
              vm.disableForm = false;
              row.merchant = {};
              row.merchant.data_release = 1;
            } else {
              console.log('nada', response);
              vm.asyncFormError = response.data.status + ': ' + response.data.message;
              vm.disableForm = false;
            }
          }).catch(function (error) {
            vm.asyncFormError = errorModel.apiError(error, vm.$router);
            vm.disableForm = false;
          }
      );
    },
    addBankDetailsForm: function (row) {
      // Add bank details form
      const vm = this;
      vm.asyncFormError = '';
      vm.disableForm = true;

      vm.formTitle = "Add bank details for " + row.forename + " " + row.surname;
      vm.formUrl = vm.baseUrl + "/settings/add-bank-account-details";
      vm.formSchema = [
        {
          "type": "hidden",
          "name": "user_id",
          "model": row.id.toString(),
          "class": "Input--hidden"
        },
        {
          "type": "text",
          "name": "account_name",
          "label": "Account name",
          "placeholder": "Account name",
          "model": "",
          "required": true,
          "class": "Input--accountName"
        },
        {
          "type": "number",
          "name": "sort_code",
          "label": "Sort code",
          "placeholder": "XXXXXX",
          "model": "",
          "required": true,
          "class": "Input--sortCode"
        },
        {
          "type": "number",
          "name": "account_number",
          "label": "Account number",
          "placeholder": "XXXXXXXX",
          "model": "",
          "required": true,
          "class": "Input--accountNumber"
        }
      ];
      vm.showForm = true;
    },
    updateQueryParams: function (params) {
      history.pushState(
        {},
        null,
        '/#' + this.$router.currentRoute.path +
        '?' +
        Object.keys(params)
          .map(key => {
            return (
                encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            )
          })
          .join('&')
      )
    },
    blockUser: function (user) {
      const vm = this;
      vm.asyncFormError = '';
      vm.disableForm = true;

      // Add authorisation to request header
      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      vm.axiosInstance.post(vm.baseUrl + "/admin/users/" + user.id + "/block")
        .then(function (response) {
          console.log('response: ', response.data);
          if (response.data && response.data.success) {
            // Update the user status in the local data
            user.status = 'Blocked';
            vm.asyncFormError = false;
            vm.disableForm = false;
            // Show success message
            vm.$nextTick(() => {
              vm.asyncFormError = response.data.message;
              setTimeout(() => {
                vm.asyncFormError = false;
              }, 3000);
            });
          } else {
            vm.asyncFormError = response.data.message || 'Failed to block user';
            vm.disableForm = false;
          }
        }).catch(function (error) {
          vm.asyncFormError = errorModel.apiError(error, vm.$router);
          vm.disableForm = false;
        });
    },
    blockUserAndMarkSpam: function (user) {
      const vm = this;
      vm.asyncFormError = '';
      vm.disableForm = true;

      // Add authorisation to request header
      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      vm.axiosInstance.post(vm.baseUrl + "/admin/users/" + user.id + "/block-and-mark-spam")
        .then(function (response) {
          console.log('response: ', response.data);
          if (response.data && response.data.success) {
            // Update the user status in the local data
            user.status = 'Blocked';
            vm.asyncFormError = false;
            vm.disableForm = false;
            // Show success message
            vm.$nextTick(() => {
              vm.asyncFormError = response.data.message;
              setTimeout(() => {
                vm.asyncFormError = false;
              }, 5000);
            });
          } else {
            vm.asyncFormError = response.data.message || 'Failed to block user and mark events as spam';
            vm.disableForm = false;
          }
        }).catch(function (error) {
          vm.asyncFormError = errorModel.apiError(error, vm.$router);
          vm.disableForm = false;
        });
    },
    trustUser: function (user) {
      const vm = this;
      vm.asyncFormError = '';
      vm.disableForm = true;

      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      vm.axiosInstance.post(vm.baseUrl + "/admin/users/" + user.id + "/trust")
        .then(function (response) {
          if (response.data && response.data.success) {
            user.user_type = 2;
            vm.asyncFormError = false;
            vm.disableForm = false;
            // Show success message
            vm.$nextTick(() => {
              vm.asyncFormError = response.data.message;
              setTimeout(() => {
                vm.asyncFormError = false;
              }, 3000);
            });
          } else {
            vm.asyncFormError = response.data.message || 'Failed to trust user';
            vm.disableForm = false;
          }
        }).catch(function (error) {
          vm.asyncFormError = errorModel.apiError(error, vm.$router);
          vm.disableForm = false;
        });
    },
    untrustUser: function (user) {
      const vm = this;
      vm.asyncFormError = '';
      vm.disableForm = true;

      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      vm.axiosInstance.post(vm.baseUrl + "/admin/users/" + user.id + "/untrust")
        .then(function (response) {
          if (response.data && response.data.success) {
            user.user_type = 1;
            vm.asyncFormError = false;
            vm.disableForm = false;
            // Show success message
            vm.$nextTick(() => {
              vm.asyncFormError = response.data.message;
              setTimeout(() => {
                vm.asyncFormError = false;
              }, 3000);
            });
          } else {
            vm.asyncFormError = response.data.message || 'Failed to remove user trust';
            vm.disableForm = false;
          }
        }).catch(function (error) {
          vm.asyncFormError = errorModel.apiError(error, vm.$router);
          vm.disableForm = false;
        });
    }
  },
  data: function () {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
      venueId: process.env.VUE_APP_VENUE_ID,
      axiosInstance: axios.create({
        baseURL: this.baseUrl,
      }),
      asyncFormError: false,
      disableForm: false,
      userToken: '',
      search: '',
      searchResults: [],
      searchResultsData: [],
      previousSearch: '',
      tableColumns: [],
      ticketColumns: [
        {
          field: "type",
          key: "type",
          title: "Type",
          align: "left",
          operationColumn: true,
          type: "expand",
        },
        {
          field: "code",
          key: "code",
          title: "Code",
          align: "left"
        },
        {
          field: "name",
          key: "name",
          title: "Name",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return (
                <span>
                {row.name}
              </span>
            );
          },
        },
        {
          field: "email",
          key: "email",
          title: "Email",
          align: "left",
          edit: true,
        },
        {
          field: "event.name",
          key: "eventName",
          title: "Event",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return (
                <span>
                <a href={row.event.url}>{row.event.name}</a>
              </span>
            );
          },
        },
        {
          field: "event.date",
          key: "eventDate",
          title: "Event Date",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            const date = row.event.date;
            return (
                <span>
                {date}
              </span>
            );
          },
        },
        {
          field: "price",
          key: "c",
          title: "Price",
          align: "right",
          type: "currency",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return (
                <span>
                {row.event.currency_symbol}{row.event.price}
              </span>
            );
          },
        },
        {
          field: "quantity",
          key: "quantity",
          title: "Quantity sold",
          align: "right"
        },
        {
          field: "has_discount_codes",
          key: "discountCodes",
          title: "Has discount codes?",
          align: "center",
          width: "200px",
          type: "boolean",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <span>
                <md-checkbox v-model={row.has_discount_codes} disabled></md-checkbox>
              </span>
            );
          },
        },
        {
          field: "timestamp",
          key: "timestamp",
          title: "Purchase datetime",
          align: "left",
        },
        {
          field: "",
          key: "actions",
          title: "Action",
          width: "",
          center: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <span>
                <a href={'https://ticketlab.co.uk/tickets/resend/' + row.code} target="_blank"
                   class="Button" style="color: #fff; text-decoration:none">
                  Resend ticket
                </a>
                <button
                    class="Button"
                    on-click={() => this.transfer(row)}>
                  Transfer
                </button>
                <button
                    class="Button"
                    on-click={() => this.refund(row)}
                    disabled={row.status === 8}>
                  {row.event.price > 0 ? 'Refund ticket' : 'Cancel ticket'}
                </button>
              </span>
            );
          },
        },
      ],
      eventColumns: [
        {
          field: "id",
          key: "id",
          title: "ID",
          align: "right"
        },
        {
          field: "status_type",
          key: "status_type",
          title: "Status",
          align: "left",
        },
        {
          field: "name",
          key: "name",
          title: "Name",
          align: "left"
        },
        {
          field: "event.date",
          key: "eventDate",
          title: "Event Date",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            const date = row.date;
            return (
                <span>
                {date}
              </span>
            );
          },
        },
        {
          field: "price",
          key: "c",
          title: "Price",
          align: "right",
          type: "currency",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return (
                <span>
                {row.currency_symbol}{row.price}
              </span>
            );
          },
        },
        {
          field: "quantity",
          key: "quantity",
          title: "Quantity",
          align: "right"
        },
        {
          field: "sold",
          key: "sold",
          title: "Sold",
          align: "right"
        },
        {
          field: "user_id",
          key: "organiser",
          title: "Organiser",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            const user = row.user ?? {
              id: '',
              forename: '',
              surname: '',
            };
            return (
                <span>
                id: {user.id} <br/>
                  {user.forename} {user.surname}
              </span>
            );
          },
        },
        {
          field: "locale",
          key: "locale",
          title: "Locale",
          align: "left"
        },
        {
          field: "payment_date",
          key: "paymentDate",
          title: "Payment Date",
          align: "left"
        },
        {
          field: "has_discount_codes",
          key: "discountCodes",
          title: "Has discount codes?",
          align: "center",
          width: "200px",
          type: "boolean",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <span>
                <md-checkbox v-model={row.has_discount_codes} disabled></md-checkbox>
              </span>
            );
          },
        },
        {
          field: "",
          key: "actions",
          title: "Action",
          width: "",
          center: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <span>
                <button
                    class="Button"
                    on-click={() => this.showTickets(row.id)}>
                  Show Tickets
                </button>
                <button
                    class="Button"
                    on-click={() => this.markEventAsSpam(row)}
                    disabled={row.status === 7 || row.status_type === 'SPAM'}>
                  {row.status === 7 || row.status_type === 'SPAM' ? 'Marked as Spam' : 'Mark as Spam'}
                </button>
              </span>
            );
          },
        },
      ],
      userColumns: [
        {
          field: "id",
          key: "id",
          title: "ID",
          align: "right",
          operationColumn: true,
          type: "expand",
        },
        {
          field: "name",
          key: "name",
          title: "Name",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return (
                <span>
                {row.forename} {row.surname}
              </span>
            );
          },
        },
        {
          field: "email",
          key: "email",
          title: "Email",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            const email = row.email ? row.email : '';
            const mailToEmail = row.email ? 'mailto:' + row.email : '';
            return (
                <span>
                <a href={mailToEmail}>{email}</a>
              </span>
            );
          },
        },
        {
          field: "tickets.length",
          key: "tickets.length",
          title: "Number of tickets",
          align: "right",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return (
                <span>
                {row.tickets.length}
              </span>
            );
          },
        },
        {
          field: "events.length",
          key: "events.length",
          title: "Number of events",
          align: "right",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return (
                <span>
                {row.events.length}
              </span>
            );
          },
        },
        {
          field: "timestamp",
          key: "timestamp",
          title: "Signed up",
          align: "left",
        },
        {
          field: "status",
          key: "status",
          title: "Status",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            const status = row.status || 'Valid';
            const statusClass = status === 'Blocked' ? 'User-status--blocked' : 'User-status--valid';
            return (
              <span class={statusClass}>
                {status}
              </span>
            );
          },
        },
        {
          field: "user_type",
          key: "userType",
          title: "User Type",
          align: "left",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            const userType = row.user_type || 1;
            const userTypeText = userType === 0 ? 'Admin' : 
                               userType === 2 ? 'Trusted' : 
                               userType === 3 ? 'Artist' : 
                               userType === 4 ? 'Attendee' : 
                               userType === 5 ? 'Mailing List' : 'Promoter';
            const userTypeClass = userType === 2 ? 'User-type--trusted' : 'User-type--normal';
            return (
              <span class={userTypeClass}>
                {userTypeText}
              </span>
            );
          },
        },
        {
          field: "quantity",
          key: "quantity",
          title: "Quantity sold",
          align: "right"
        },
        {
          field: "merchant.data_release",
          key: "dataRelease",
          title: "Data Release",
          align: "center",
          width: "200px",
          type: "boolean",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row, column, rowIndex}, h) => {
            const dataRelease = !!(row.merchant && row.merchant.data_release);
            return (
                <span>
                <md-checkbox v-model={dataRelease} disabled></md-checkbox>
              </span>
            );
          },
        },
        {
          field: "",
          key: "actions",
          title: "Action",
          width: "",
          center: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let content = [];

            if (!row.merchant || (row.merchant && !row.merchant.data_release)) {
              content.push(
                <button
                  class="Button"
                  on-click={() => this.optInDataRelease(row)}>
                  Opt in data release
                </button>
              );
            }

            content.push(
              <button
                class="Button"
                on-click={() => this.addBankDetailsForm(row)}>
                Add bank details
              </button>
            );

            const userId = row.id;

            content.push(
              <RouterLink
                class="Button"
                to={`/payments/due/${row.id}`}>
                View payment details
              </RouterLink>
            );

            // Add user trust actions
            if (row.user_type === 2) {
              content.push(
                <button
                  class="Button Button--success"
                  on-click={() => this.untrustUser(row)}
                  disabled={this.disableForm}>
                  Remove Trust
                </button>
              );
            } else {
              content.push(
                <button
                  class="Button Button--info"
                  on-click={() => this.trustUser(row)}
                  disabled={this.disableForm}>
                  Trust User
                </button>
              );
            }

            // Add user blocking actions
            if (row.status !== 'Blocked') {
              content.push(
                <button
                  class="Button Button--warning"
                  on-click={() => this.blockUser(row)}
                  disabled={this.disableForm}>
                  Block User
                </button>
              );

              content.push(
                <button
                  class="Button Button--danger"
                  on-click={() => this.blockUserAndMarkSpam(row)}
                  disabled={this.disableForm}>
                  Block & Mark Events as Spam
                </button>
              );
            } else {
              content.push(
                <span class="Button Button--disabled" style="opacity: 0.6; cursor: not-allowed;">
                  User Blocked
                </span>
              );
            }

            return (
              <span>
              {content}
              </span>
            );
          },
        },
      ],
      cellStyleOption: {
        bodyCellClass: ({row, column}) => {
          if (column.type === "boolean") {
            if (row[column.field] === true) {
              return "isTrue";
            }
          }
        },
      },
      rowStyleOption: {
        clickHighlight: true,
        hoverHighlight: false,
      },
      expandOption: {
        render: ({row, column, rowIndex}, h) => {
          console.log(row);
          return <TicketTable row={row}/>;
        },
      },
      // edit option
      editOption: {
        beforeCellValueChange: ({row, column, changeValue}) => {
          console.log("beforeCellValueChange");
          console.log("row::", row);
          console.log("column::", column);
          console.log("changeValue::", changeValue);

          console.log("---");

          if (column.field === "number" && !/^\d+$/.test(changeValue)) {
            alert("please enter a number");
            return false;
          }
        },
        afterCellValueChange: ({row, column, changeValue}) => {
          console.log("afterCellValueChange");
          console.log("row::", row);
          console.log("column::", column);
          console.log("changeValue::", changeValue);
          console.log("---");

          const vm = this;

          const postData = {
            [column.key]: changeValue,
            'ticketCode': row.code
          }

          const url = this.baseUrl + "/einstein/ticket/edit/" + column.key;
          // Add authorisation to request header
          vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

          // post updated value to server /api/einstein/ticket/edit/email
          vm.axiosInstance.post(url, postData)
              .then(function (response) {
                console.log('response: ', response.data)
                if (response.data && response.data.status === "success") {
                  console.log('form success', response);
                } else {
                  console.error('form error', response);
                  vm.asyncFormError = response.data.status + ': ' + response.data.message;
                }
              }).catch(function (error) {
            vm.asyncFormError = errorModel.apiError(error, vm.$router);
            vm.disableForm = false;
          });
        },
      },
      searchBy: 'ticket',
      showTransfer: false,
      showRefund: false,
      transferSubject: false,
      refundSubject: false,
      onlyUpcoming: true,
      formSchema: {},
      formUrl: '',
      showForm: false,
      formTitle: '',
    }
  }
}
</script>
